import type {
  QueryFormatFilter,
  QueryLeaf,
  QueryListOperandEnum,
  QueryMapOperandEnum,
} from '../domains/global-filters/model/QueryFormat';
import { QueryKeyEnum } from '../domains/global-filters/model/QueryFormat';

function getFlatKeys(
  filter: QueryFormatFilter | QueryLeaf,
): Array<QueryKeyEnum | QueryListOperandEnum | QueryMapOperandEnum> {
  if (Array.isArray(filter)) {
    return filter.flatMap(getFlatKeys);
  }

  if (typeof filter === 'object') {
    return Object.entries(filter).flatMap(([key, value]) => [
      key as QueryKeyEnum | QueryListOperandEnum | QueryMapOperandEnum,
      ...getFlatKeys(value),
    ]);
  }

  return [];
}

export function hasCommentedFilter(segmentFilter: QueryFormatFilter): boolean {
  const filterKeys = getFlatKeys(segmentFilter);

  if (filterKeys.includes(QueryKeyEnum.commented)) {
    return true;
  }

  return false;
}
